const validate = (formData) => {
    const errors = {};
    if(!formData.groups || formData.groups.length === 0){
      errors.groups = true;
    }
    return errors;
}

export default validate;